var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { createStyles } from 'antd-style';
var useStyles = createStyles(function (_ref, _ref2) {
  var token = _ref.token,
    css = _ref.css,
    prefixCls = _ref.prefixCls;
  var size = _ref2.size;
  var isSmall = size === 'small';
  return {
    breadcrumbWrap: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      font-size: ", "px;\n      line-height: ", "px;\n      .", "-breadcrumb-separator {\n        font-size: 12px;\n      }\n    "])), isSmall ? 12 : 14, isSmall ? 20 : 22, prefixCls)
  };
});
export default useStyles;